exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-button__button__3uWSE{background:none;border:none;outline:none;padding:0;height:100%;cursor:pointer}.menu-button__icon__170gY{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:60px;height:100%}.menu-button__icon__170gY svg{fill:-wix-colors-buttonsAndLinksColor;width:22px;margin:0 auto}.menu-button__icon__170gY:hover{opacity:.7}", ""]);

// exports
exports.locals = {
	"button": "menu-button__button__3uWSE",
	"icon": "menu-button__icon__170gY"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/menu-button/menu-button.styl
// module id = 2939
// module chunks = 1